import React, { useState, useEffect } from "react";

// DevExteme components
import { Switch } from 'devextreme-react/switch';

const EMPTY = null;

export function SwitchWidget(props) {
  const { ui, data, writeBack } = props;
  const widgetId = ui.id;

  const [localContent, setLocalContent] = useState(EMPTY);

  let stringContent = localContent !== EMPTY ? localContent : data && data.content ? data.content.toLowerCase() : "null";
  let content = stringContent === "true";
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    //console.log("SwitchWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const setContent = value => {
    setLocalContent(value.toString());
    writeBack(value.toString(), true);
  };

  return (
    <Switch
      id={widgetId}
      value={content}
      onValueChanged={e => setContent(e.value)}
      disabled={disabled}
      height={ui.controlHeight + "em"}
    />
  );
}
